/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react';

/**
 * LoadingOverlay Component
 * @returns {JSX.Element}
 * @constructor
 */
export default function LoadingOverlay() {
  return (
    <Backdrop open className="app-loading-overlay">
      <CircularProgress size={50} color="inherit" />
    </Backdrop>
  );
}
